<template>
    <v-container grid-list-md>
        <form v-on:submit.prevent="update">

            <v-layout row wrap v-if="data">
                <v-flex xs6 s6 md6>
                    <v-text-field
                            v-validate="'required'"
                            v-model="data.request_"
                            :error-messages="errors.collect('data.request_')"
                            label="Sample request"
                            data-vv-name="data.request_"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs6 s6 md6>
                    <v-autocomplete
                            v-model="data.client_id"
                            :items="clients"
                            label="Client"
                            item-text="company_name"
                            item-value="id"
                            v-on:change="debouncedRellenarCampos(false)"
                            browser-autocomplete="off"
                    >
                    </v-autocomplete>
                </v-flex>

                <v-flex xs6 s6 md6>
                    <v-text-field
                            v-validate="''"
                            v-model="data.final_client"
                            :error-messages="errors.collect('data.final_client')"
                            label="Final client"
                            data-vv-name="data.final_client"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs6 s6 md6>
                    <v-text-field
                            v-validate="''"
                            v-model="data.contact_person"
                            :error-messages="errors.collect('data.contact_person')"
                            label="Contact person"
                            data-vv-name="data.contact_person"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs6 sm6 md6>
                    <v-autocomplete
                            v-validate="''"
                            :items="direcciones"
                            item-text="direccion_envio"
                            label="Shipping address"
                            item-value="id"
                            v-model="data.shipping_address"
                            data-vv-name="data.shipping_address"
                            :error-messages="errors.collect('data.shipping_address')"
                            clearable
                            browser-autocomplete="off"
                    ></v-autocomplete>
                    <CreateDireccionEnvioComponent :id="data.client_id" v-on:created="crearDireccion"></CreateDireccionEnvioComponent>
                </v-flex>

                <v-flex xs6 sm6 md6>
                    <v-autocomplete
                            v-validate="''"
                            :items="paises"
                            item-text="name"
                            label="Country"
                            item-value="id"
                            v-model="data.country_id"
                            data-vv-name="data.country_id"
                            :error-messages="errors.collect('data.country_id')"
                            browser-autocomplete="off"
                    ></v-autocomplete>
                </v-flex>

                <v-flex xs6 s6 md6>
                    <v-text-field
                            v-validate="''"
                            v-model="data.account_manager"
                            :error-messages="errors.collect('data.account_manager')"
                            label="Account manager"
                            data-vv-name="data.account_manager"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs6 s6 md6>
                    <v-menu
                            :close-on-content-click="false"
                            v-model="menu"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                    >
                        <v-text-field
                                v-validate="''"
                                slot="activator"
                                v-model="data.date"
                                :error-messages="errors.collect('data.date')"
                                label="Date"
                                data-vv-name="data.date"
                                readonly
                                browser-autocomplete="off"
                        ></v-text-field>
                        <v-date-picker v-model="data.date" @input="menu = false"></v-date-picker>
                    </v-menu>
                </v-flex>

                <v-flex xs6 s6 md6>
                    <v-text-field
                            v-validate="''"
                            v-model="data.customer_courier_number"
                            :error-messages="errors.collect('data.customer_courier_number')"
                            label="Customer courier number"
                            data-vv-name="data.customer_courier_number"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs6 s6 md6>
                    <v-autocomplete
                            v-model="data.status_id"
                            :items="statuses"
                            label="Status"
                            item-text="name"
                            item-value="id"
                            browser-autocomplete="off"
                    >
                    </v-autocomplete>
                </v-flex>

                <v-flex xs6 sm6 md6>
                    <v-autocomplete
                            v-validate="'required'"
                            :items="laboratorios"
                            item-text="name"
                            label="Laboratory"
                            item-value="id"
                            v-model="data.laboratorio_id"
                            data-vv-name="data.laboratorio_id"
                            :error-messages="errors.collect('data.laboratorio_id')"
                            browser-autocomplete="off"
                    ></v-autocomplete>
                </v-flex>

                <v-flex xs12 s12 md12>
                    <v-textarea
                            box
                            name="input-7-4"
                            label="Sample request comments"
                            v-model="data.comments"
                            browser-autocomplete="off"
                    ></v-textarea>
                </v-flex>

                <v-flex xs12 md12>
                    <v-btn large color="secondary" class="text--primary" type="submit">Edit sample request</v-btn>
                </v-flex>
            </v-layout>
            <br>
        </form>
        <br>
        <CommentComponent :sample="sample"></CommentComponent>
    </v-container>
</template>

<script>
    import CommentComponent from './components/CommentComponent';
    import CreateDireccionEnvioComponent from '../components/CreateDireccionEnvioModal'

    export default {
        props: ['sample'],
        data : function() {
            return {
                data : null,
                error : false,
                message_error : null,
                dictionary: {
                    custom: {
                    }
                },
                clients: null,
                statuses: [],
                menu: false,
                paises: null,
                direcciones: null,
                laboratorios: []
            }
        },
        created: function () {
            this.getLaboratorios();
            this.getCountries();
            this.getClients();
            this.getStatuses();
            this.data = Object.assign({}, this.sample);
            if (this.data.shipping_address_obj) {
                this.data.shipping_address = this.data.shipping_address_obj.id;
            }
            this.rellenarCampos(true);
            this.debouncedRellenarCampos = _.debounce(this.rellenarCampos, 100)
        },
        watch: {
            sample: function (val) {
                this.data = Object.assign({}, this.sample);
                if (this.data.shipping_address_obj) {
                    this.data.shipping_address = this.data.shipping_address_obj.id;
                }
                this.rellenarCampos(true);
            }
        },
        methods: {
            getLaboratorios () {
                this.$store.dispatch('getLaboratoriosSelect', {}).then((res) => {
                    this.laboratorios = res.data;
                }).catch((error) => {

                });
            },
            getCountries () {
                this.$store.dispatch('getSelectCountry').then((res) => {
                    this.paises = res.data;
                }).catch((error) => {

                });
            },
            getStatuses () {
                this.$store.dispatch('getStatusSampleOrders').then((res) => {

                    this.statuses = res.data.data;

                }).catch((error) => {
                });
            },
            update : function() {
                this.$validator.validateAll().then((result) => {
                    if(result){
                        if (this.data.shipping_address == undefined) {
                            this.data.shipping_address = 'null';
                        }
                        this.$store.dispatch('updateSample', {
                            id: this.sample.id,
                            data : this.data
                        }).then((res) => {

                            this.$emit('updated')
                            this.rellenarCampos(true);

                        }).catch((error) => {
                        });
                    }
                });

            },
            getClients () {
                this.$store.dispatch('getClientsSelect').then((res) => {
                    this.clients = res.data;
                }).catch((error) => {

                });
            },
            crearDireccion (direccion) {
                this.$store.dispatch('createClientDireccionesEnvio', direccion).then((res) => {
                    this.rellenarCampos();
                }).catch((error) => {

                });
            },
            rellenarCampos (first) {
                console.log(first);
                if (this.data.client_id) {
                    this.$store.dispatch('getClient', {
                        id: this.data.client_id
                    }).then((res) => {
                        this.direcciones = res.data.shipping_address;
                        if (first == true) {
                            if (this.data.shipping_address_obj) {
                                this.data.shipping_address = this.data.shipping_address_obj.id;
                            } else {
                                //this.data.shipping_address = res.data.shipping_address_default.id;
                            }
                        } else {
                            this.data.shipping_address = res.data.shipping_address_default.id;
                        }
                    }).catch((error) => {

                    });
                }
            },
        },
        components: {
            CommentComponent,
            CreateDireccionEnvioComponent
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/samples/views/SampleOrderComponent.vue